import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import Preview from '@components/leadmagnets/wallex/sections/preview';
import DownloadStory from '@components/leadmagnets/wallex/sections/download-story';
import ScheduleCall from '@components/leadmagnets/wallex/sections/schedule-call';
import TrustedBy from '@components/leadmagnets/wallex/sections/trusted-by';

const WallexComponent = () => {
  return (
    <>
      <Breadcrumbs/>
      <Preview/>
      <DownloadStory/>
      <ScheduleCall/>
      <TrustedBy/>
    </>
  )
};

export default WallexComponent;
